import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faCheckCircle, faThermometerHalf, faTimesCircle } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeadingItem } from 'components'
import { TripContext } from 'contexts'
import React, { FC, useContext } from 'react'
import { useReturnItemService } from 'services'
import { LineItem, ReturnItem } from 'services/types'
import { IconOptions } from 'types'
import './return-item-card.scss'


type Props = {
    returnItemId: number
}

export const ReturnItemCard: FC<Props> = ({ returnItemId }) => {

    const tripContext = useContext(TripContext)
    const { isReturnItemCompleted } = useReturnItemService()

    const returnItem: ReturnItem = tripContext.returnItems.find(ri => ri.id == returnItemId) ?? {} as ReturnItem
    const lineItem: LineItem = tripContext.lineItems.find(l => l.id == returnItem.lineItemId) ?? {} as LineItem

    const renderRightHandIcon = (): IconOptions => {
        let icon: IconOptions = {} as IconOptions;
        icon = isReturnItemCompleted(returnItem) ? { icon: faCheckCircle, color: '#76AB21', size: '2x' }
            : { icon: faTimesCircle, color: '#EB5757', size: '2x' }

        return icon
    }

    return (
        <div className={'search-result-card-material'}>
            <HeadingItem text={(lineItem.longDescription ?? lineItem.description ?? 'Unknown Item').toLowerCase()}
                rightHandIcon={returnItem.countedQuantity != null ? renderRightHandIcon() : {} as IconOptions}
                leftHandRender={() => <div className={'card-badge'}>RTN</div>}
            />
            <div className={'item-card-content-container'}>
                <div className={'list-subheading'}>Return : {returnItem.returnQuantity}</div>
                <div className={'list-subheading'}>Counted : {returnItem.countedQuantity ?? 0}</div>
                <div className={'item-card-content-temperature'}>
                    <FontAwesomeIcon icon={faThermometerHalf as IconProp} color='Red' size='1x' />
                    <div className={'list-subheading'} style={{ paddingLeft: "10px" }}>{lineItem.temperature}</div>
                </div>
            </div>
        </div>
    )
}